import themeConfig from './themeConfig';
import dateConfig from './dataConfig'; // 文件名是dataConfig.ts
import netConfig from './netConfig';
import { msSpaceAuthConfig } from './authConfig';
import * as routeConfig from './routeConfig';

// 从 routeConfig 中导出 routerConfig
export const { routerConfig } = routeConfig;

export {
  themeConfig,
  dateConfig,  // 导出名是dateConfig
  netConfig,
  msSpaceAuthConfig,
  routeConfig
};